import { Route, Routes } from "react-router-dom";
import EgibModule from ".";

const EgibRoute = () => {
  return (
    <Routes>
      <Route path="/*" element={<EgibModule />} />
    </Routes>
  );
};

export default EgibRoute;
